module.exports = __webpack_public_path__ + "media/images/mic-icon-719d482395e93a8f710201bb769d399e.png";